import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import ErrorIcon from '@material-ui/icons/Error'

import Page from 'components/Page'

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  description: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  }
}))

const ErrorLayout = ({ children, title, icon: Icon = ErrorIcon, description }) => {
  const classes = useStyles()

  return (
    <Page
      classes={{
        root: classes.container
      }}
      headTitle={title}
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="md">
          <Box textAlign="center">
            <Icon style={{ fontSize: 80 }} />
          </Box>
          <Typography
            className={classes.description}
            align="center"
            color="textPrimary"
            variant="h3"
          >
            {description}
          </Typography>
          {children}
        </Container>
      </Box>
    </Page>
  )
}

export default ErrorLayout
